export interface StepConfig {
  title: string;
  field: string;
  placeholder: string;
  type: 'input' | 'textarea' | 'upload';
}

export const promptSteps: StepConfig[] = [
  {
    title: "What's the specific decision needed?",
    field: 'decisionNeeded',
    placeholder: 'Describe the key decision that needs to be made and its importance to the business',
    type: 'textarea'
  },
  {
    title: "What are the customer pain points and business goals?",
    field: 'contextAndGoals',
    placeholder: 'Detail the customer pain points being addressed, business goals, and key success metrics for this decision',
    type: 'textarea'
  },
  {
    title: "What options are being considered?",
    field: 'optionsConsidered',
    placeholder: 'List and briefly describe the main options being considered for this decision',
    type: 'textarea'
  },
  {
    title: "What are the timeline and constraints?",
    field: 'constraints',
    placeholder: 'Outline any important deadlines, resource constraints, or other limiting factors that impact this decision',
    type: 'textarea'
  },
  {
    title: "What format would you like for the final output?",
    field: 'outputFormat',
    placeholder: 'For example: Decision doc, Executive summary, Presentation slides, etc.',
    type: 'textarea'
  },
  {
    title: "Do you have any supporting materials to include?",
    field: 'referenceFiles',
    placeholder: 'Please include any relevant data, research, or documentation that helps inform this decision.',
    type: 'upload'
  }
]